import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import PlanQuota from '@/modules/profile/PlanQuota'
import { Stack } from 'expo-router'

export default function PlanQuotaPage() {
  const headerLeftItems = useWebBackButton('/profile')

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <PlanQuota />
    </>
  )
}
